import { useCallback } from 'react';
import { Index } from 'react-virtualized';

import { User } from '@/types/userList';

export const DEFAULT_ROW_HEIGHT = 75;
export const SELECTED_ROW_HEIGHT = 355;

export const useCalcRowHeight = (
  isPreview: boolean,
  selectedUserId: number | null,
  users: User[],
) => {
  // 受講者一覧の行データと編集フォームの高さを返す
  const calcRowHeight = useCallback<(info: Index) => number>(
    (info) => {
      if (isPreview) {
        return DEFAULT_ROW_HEIGHT;
      }

      const user = users[info.index];

      if (user && user.id === selectedUserId) {
        return SELECTED_ROW_HEIGHT;
      }

      return DEFAULT_ROW_HEIGHT;
    },
    [isPreview, selectedUserId, users],
  );

  return { calcRowHeight };
};
